<template>
    <div>

            <TipTap
                v-model="editable_content.question"
                :class="{'is-invalid': validating && !editable_content.question}"
                :menu_items="['bold', 'italic', 'underline', 'bullet_list', 'ordered_list', 'image', 'edit_html']"
                :article="article"
                @input="setContent('question', $event)"
            />
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import { mapState } from 'vuex'


export default {
    data: () => ({
        editable_content: {

        }
    }),
    props: [
        'question',
        'article'
    ],
    components: {
        TipTap: () => import('@/components/tiptap/TipTap')
    },
    computed: {
        ...mapState({
            validating: state => state.utilities.validating
        })
    },
    watch: {
        question: {
            handler (question) {
                if (
                    question &&
                    question.content
                ) {
                    this.editable_content = question.content
                }
            },
            deep: true,
            immediate: true
        },
        editable_content: {
            handler (editable_content) {
                if (editable_content) {
                    this.$set(this.question, 'content', editable_content)
                }
            },
            deep: true
        }
    },
    methods: {
        setContent (field, value) {
            this.$set(this.editable_content, field, value)
        }
    }
}
</script>
